import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import { ORGANIZATION_TASK_TEMPLATE_FILTER_MAX_IDS } from "@common/schemas/organization-task-template.schema";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { buildWorkspaceMemberFilterOptions } from "@components/pageHeader/filters/workspaceMemberFilter.lib";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

export const OrgTaskTemplateCreatedByFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: members = [] } = useCurrentOrganizationMembers();

    const selectedIds = filters.orgTaskTemplateCreatedByUserIds;

    const options = useMemo(
        (): FilterMultiselectOption[] =>
            buildWorkspaceMemberFilterOptions({
                members,
                selectedUserIds: selectedIds,
            }),
        [members, selectedIds],
    );

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                options={options}
                value={selectedIds ?? []}
                onChange={(val) => {
                    const ids = val.filter(
                        (v): v is number => typeof v === "number",
                    );
                    onChange({
                        orgTaskTemplateCreatedByUserIds: ids.length
                            ? ids.slice(
                                  0,
                                  ORGANIZATION_TASK_TEMPLATE_FILTER_MAX_IDS,
                              )
                            : undefined,
                    });
                }}
                name="orgTaskTemplateCreatedByUserIds"
                onBlur={noop}
                searchable
            />
        </div>
    );
};
